import { useQuery } from '@tanstack/react-query';
import { map, mapValues, keyBy } from 'lodash';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedDataArray } from 'src/types/requestData';
import { getRequest } from 'src/utils/request';

const excludeFields = [
  'User ID',
  'Job ID',
  'Project ID',
  'Project type',
  'Type',
  'Status',
  'Signature status',
];

const mapContractFilters = (
  data: {
    id: string;
    type: string;
    attributes: UCM.DynamicFiltersAttributesRawType;
  }[],
) => {
  const filteredData = data.filter(
    (filter) => !excludeFields.includes(filter.attributes.field_name),
  );
  const fields = map(filteredData, (filter) => ({
    label: filter.attributes.field_name,
    value: filter.attributes.field_name,
  }));
  const types = mapValues(keyBy(data, 'attributes.field_name'), (filter) =>
    filter.attributes.field_type?.toLowerCase(),
  );
  const operators = mapValues(keyBy(data, 'attributes.field_name'), (filter) =>
    map(filter.attributes.operators, (operator) => ({
      label: operator.label,
      value: operator.code,
    })),
  );
  const options = mapValues(
    keyBy(data, 'attributes.field_name'),
    (filter) => filter.attributes.options,
  );
  return { fields, types, operators, options };
};

const getContractFilters = async () => {
  const {
    data: { data },
  } = await getRequest<RequestSimplifiedDataArray<UCM.DynamicFiltersRawType>>(
    API.GET.getContractFilters,
  );

  return mapContractFilters(data);
};

export const useGetContractFilters = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONTRACTS_FILTERS],
    queryFn: () => getContractFilters(),
    staleTime: 1000 * 60 * 30,
    ...config,
  });
};
